export default __webpack_public_path__ + "static/media/SalesReport.1fbaa217.jpg";